import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { EnrollmentBenefitCategoryItem } from "src/app/models/enrollment-category";
import { WidgetError } from "src/app/models/widget";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";

@Component({
    selector: 'mwp-benefit-enrollment-category-finalize',
    templateUrl: './category-finalize.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BenefitEnrollmentCategoryFinalizeComponent implements OnInit {
    @Input() public isCheckoutEnabled: boolean;
    @Input() public nextCategory: EnrollmentBenefitCategoryItem;

    @Output() public currentCategroy: EventEmitter<any> = new EventEmitter();
    @Output() public gotoNextCategroy: EventEmitter<any> = new EventEmitter();
    @Output() public initializeCheckout: EventEmitter<any> = new EventEmitter();

    public widgetErrorModel: WidgetError;
    public widgetError: boolean;
    public title: string;

    constructor(
        private enrollmentManagerService: EnrollmentManagerService,
    ) {
    }

    ngOnInit(): void {
        this.enrollmentManagerService.manager.selectedBenefitName =
            this.enrollmentManagerService.manager.selectedBenefitAvailable = null;

        this.widgetErrorModel = this.enrollmentManagerService.manager.widgetErrorModel;
        this.widgetError = this.enrollmentManagerService.manager.widgetErrorModel.title != null;

        if (this.widgetErrorModel?.title) {
            this.title = `${this.enrollmentManagerService.manager.selectedCategoryName} Widget Error!`;
        } else {
            this.title = `${this.enrollmentManagerService.manager.selectedCategoryName} Complete!`;
        }
    }

    private resetWidgetErrorModel(): void {
        if (this.widgetErrorModel) {
            this.enrollmentManagerService.manager.widgetErrorModel = null;
            this.enrollmentManagerService.setCacheManager();
        }
    }

    stayOnCategory(): void {
        this.enrollmentManagerService.$CancelBenefitWizard.next(true);
        this.resetWidgetErrorModel();
        this.currentCategroy.emit();
    }

    gotoNextCategory(): void {
        this.resetWidgetErrorModel();
        this.gotoNextCategroy.emit();
    }

    goToCheckout(): void {
        this.resetWidgetErrorModel();
        this.initializeCheckout.emit();
    }
}